import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ClientStickerPart } from 'src/app/model/product/windowsticker/client-sticker-part';
import { ClientWindowSticker } from 'src/app/model/product/windowsticker/client-windowsticker';
import { isStandardStickerPart } from 'src/app/model/product/windowsticker/standard-sticker-part';
import { isStickerPart } from 'src/app/model/product/windowsticker/sticker-part';
import { EMPTY_OBJECT } from 'src/globals/globals';
import { WindowStickerSizeGetter } from '../helper/window-sticker-size-getter';
import {
  ClientWindowStickerPartFormHelper,
  StickerPartTypeChoice
} from './helper/client-window-sticker-part-form-helper';

@Component({
  selector: 'client-window-sticker-part-form',
  templateUrl: './client-window-sticker-part-form.component.html',
  styleUrls: ['./client-window-sticker-part-form.component.scss']
})
export class ClientWindowStickerPartFormComponent implements OnInit {
  @Input()
  windowSticker: ClientWindowSticker;

  @Input()
  part: ClientStickerPart;

  @Input()
  index: number;

  @Input()
  enableDelete: boolean;

  @Input()
  windowStickerSizeGetter: WindowStickerSizeGetter;

  @Output()
  typeIsSelected = new EventEmitter<any>();

  isStandardStickerPart: boolean = false;
  isCustomStickerPart: boolean = false;

  STICKER_PART_TYPE_CHOICES =
    ClientWindowStickerPartFormHelper.STICKER_PART_TYPE_CHOICES;
  STICKER_PART_TYPE_CHOICES_ARRAY =
    ClientWindowStickerPartFormHelper.STICKER_PART_TYPE_CHOICES_ARRAY;
  selectedStickerPartType: StickerPartTypeChoice;

  ngOnInit(): void {
    this.determinePartType();
  }

  private determinePartType(): void {
    if (isStandardStickerPart(this.part.instance)) {
      this.isStandardStickerPart = true;
      this.isCustomStickerPart = false;
      this.selectedStickerPartType =
        ClientWindowStickerPartFormHelper.STICKER_PART_TYPE_CHOICES.STANDARD_STICKER_PART;
    } else if (isStickerPart(this.part.instance)) {
      this.isStandardStickerPart = false;
      this.isCustomStickerPart = true;
      this.selectedStickerPartType =
        ClientWindowStickerPartFormHelper.STICKER_PART_TYPE_CHOICES.CUSTOM_STICKER_PART;
    } else {
      this.isStandardStickerPart = false;
      this.isCustomStickerPart = false;
      this.selectedStickerPartType = null;
    }
  }

  typeSelected(type: StickerPartTypeChoice): void {
    this.part.instance = type == null ? EMPTY_OBJECT : type.initializer();
    this.determinePartType();
    this.typeIsSelected.emit();
  }
}
